import { detectEnvironment } from "../utils";
import { AppApiGatewayService } from ".";

export interface ServiceConfig {
    endpoint: string;
    region: string;
}

export interface AppServiceConfig {
    [environment: string]: ServiceConfig;
}

export class ApiGatewayFactory {
    static async createService(appConfigs: AppServiceConfig): Promise<AppApiGatewayService> {
        const environment = detectEnvironment();
        const config = appConfigs[environment] || appConfigs.PROD;

        return AppApiGatewayService.create(config.endpoint, config.region);
    }
}